import React from 'react';
import './aragovde.css';
import hasSt50 from '../assets/nefes/HAS ST50.jpg';
import hasSt100 from '../assets/nefes/HAS ST100.jpg';
import hasSt250 from '../assets/nefes/HAS ST250.jpg';
import hasSt500 from '../assets/nefes/HAS ST500.jpg';
import hasSt1000 from '../assets/nefes/HAS ST1000.jpg';
import { useLanguage } from '../contexts/LanguageContext';

const Aragovde: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="aragovde-container">
      <div className="aragovde-content">
        <h2 className="aragovde-title">{t('aragovde.hasGumusUrunleri')}</h2>
        <div className="aragovde-grid">
          <div className="aragovde-item">
            <img src={hasSt50} alt="HAS ST50" className="aragovde-image" />
            <h3 className="aragovde-item-title">HAS ST50</h3>
          </div>
          <div className="aragovde-item">
            <img src={hasSt100} alt="HAS ST100" className="aragovde-image" />
            <h3 className="aragovde-item-title">HAS ST100</h3>
          </div>
          <div className="aragovde-item">
            <img src={hasSt250} alt="HAS ST250" className="aragovde-image" />
            <h3 className="aragovde-item-title">HAS ST250</h3>
          </div>
          <div className="aragovde-item">
            <img src={hasSt500} alt="HAS ST500" className="aragovde-image" />
            <h3 className="aragovde-item-title">HAS ST500</h3>
          </div>
          <div className="aragovde-item">
            <img src={hasSt1000} alt="HAS ST1000" className="aragovde-image" />
            <h3 className="aragovde-item-title">HAS ST1000</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aragovde; 